import _objectSpread from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4909110f"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content-shape container pt-4"
};
var _hoisted_2 = {
  class: "d-flex flex-row align-items-center justify-content-between"
};
var _hoisted_3 = {
  key: 0,
  class: "actions text-end"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode("Edit");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Delete");

var _hoisted_6 = /*#__PURE__*/_createTextVNode("Leave");

var _hoisted_7 = {
  key: 0,
  class: "mb-2"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" Created by ");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("Description");

var _hoisted_10 = /*#__PURE__*/_createTextVNode("View more");

var _hoisted_11 = /*#__PURE__*/_createTextVNode("View less");

var _hoisted_12 = /*#__PURE__*/_createTextVNode("Last messages ");

var _hoisted_13 = /*#__PURE__*/_createTextVNode("Create a new message");

var _hoisted_14 = {
  class: "messages-list p-4 rounded-3"
};

var _hoisted_15 = /*#__PURE__*/_createTextVNode("Members ");

var _hoisted_16 = {
  key: 2,
  class: "mb-4"
};

var _hoisted_17 = /*#__PURE__*/_createTextVNode("Try again");

var _hoisted_18 = {
  class: "d-flex flex-row justify-content-between mt-3 mb-4"
};
import { ref, reactive, computed, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { orderBy } from "lodash";
import { DateTime } from "luxon";
import Pusher from "pusher-js";
import { useLoadingBar, useMessage, useDialog, NH3 } from "naive-ui";
import { useMetaStore } from "@/store/meta";
import { useUserStore } from "@/store/user";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { getErrorMessage, handleError } from "@/utils/errors";
import GroupEditionAction from "@/components/groups/GroupEditionAction.vue";
import MembersUI from "@/components/groups/MembersUI.vue";
import MemberLinkAction from "@/components/groups/MemberLinkAction.vue";
import MessagesList from "@/components/messages/MessagesList.vue";
import GroupInvitationUIAction from "@/components/groups/GroupInvitationUIAction.vue";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    var router = useRouter();
    var route = useRoute();
    var metaStore = useMetaStore();
    var userStore = useUserStore();
    var loadingBar = useLoadingBar();
    var dialogAPI = useDialog();
    var messageAPI = useMessage();
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      fetch: LoaderStateEnum.Loading
    });
    var errors = reactive({});
    var fullDescription = ref(false);
    var descriptionOverflow = ref(false);
    var group = ref(null);
    var notFound = ref(false);
    var descriptionTitle = ref(null);
    var channel = null;
    var owner = computed(function () {
      var _group$value;

      return (_group$value = group.value) === null || _group$value === void 0 ? void 0 : _group$value.members.find(function (m) {
        var _group$value2;

        return m.id === ((_group$value2 = group.value) === null || _group$value2 === void 0 ? void 0 : _group$value2.ownerUserId);
      });
    });
    var isOwner = computed(function () {
      var _owner$value, _userStore$user;

      return userStore.authenticated && ((_owner$value = owner.value) === null || _owner$value === void 0 ? void 0 : _owner$value.id) === ((_userStore$user = userStore.user) === null || _userStore$user === void 0 ? void 0 : _userStore$user.id);
    });
    var members = computed(function () {
      var _group$value3;

      return orderBy((_group$value3 = group.value) === null || _group$value3 === void 0 ? void 0 : _group$value3.members, function (m) {
        return DateTime.fromISO(m.addedDate, {
          zone: "UTC"
        }).toMillis();
      }, "desc");
    });
    var messages = computed(function () {
      var _group$value4;

      return orderBy((_group$value4 = group.value) === null || _group$value4 === void 0 ? void 0 : _group$value4.lastMessages, function (m) {
        return DateTime.fromISO(m.creationDate, {
          zone: "UTC"
        }).toMillis();
      }, "desc");
    });

    var switchDescriptionState = function switchDescriptionState() {
      var _descriptionTitle$val;

      fullDescription.value = !fullDescription.value;
      if (fullDescription.value === true) return;
      var el = (_descriptionTitle$val = descriptionTitle.value) === null || _descriptionTitle$val === void 0 ? void 0 : _descriptionTitle$val.$el;
      if (!(el instanceof HTMLElement)) return;
      window.scrollTo({
        top: el.offsetTop - 10
      });
    };

    var load = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$http$get, resource;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loadingBar.start();
                loaders.fetch = LoaderStateEnum.Loading;
                _context2.prev = 2;
                _context2.next = 5;
                return http.get("/groups/".concat(route.params.id));

              case 5:
                _yield$http$get = _context2.sent;
                resource = _yield$http$get.data;
                group.value = resource;
                listen();
                metaStore.head.title = group.value.name;
                metaStore.head.description = group.value.description;
                loaders.fetch = LoaderStateEnum.Loaded;
                loadingBar.finish();
                _context2.next = 22;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](2);
                _context2.next = 19;
                return handleError(_context2.t0, {
                  placeholder: "The requested data is currently inaccessible.",
                  http: function () {
                    var _http = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                      var _e$response, _e$response2, _e$response3, _e$response3$data;

                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              notFound.value = (e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 404;
                              return _context.abrupt("return", ((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) === 404 ? "The requested group was not found." : getErrorMessage((_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : _e$response3$data.errors));

                            case 2:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function http(_x) {
                      return _http.apply(this, arguments);
                    }

                    return http;
                  }()
                });

              case 19:
                errors.fetch = _context2.sent;
                loaders.fetch = LoaderStateEnum.Failed;
                loadingBar.error();

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 15]]);
      }));

      return function load() {
        return _ref.apply(this, arguments);
      };
    }();

    var listen = function listen() {
      var _channel;

      if (!group.value || (_channel = channel) !== null && _channel !== void 0 && _channel.subscribed) return;
      channel = pusher.subscribe("group_".concat(group.value.groupId));
      channel.bind("message", function (message) {
        var _group$value5;

        return (_group$value5 = group.value) === null || _group$value5 === void 0 ? void 0 : _group$value5.lastMessages.push(message);
      });
      channel.bind("user_add", function (user) {
        var _group$value6;

        return (_group$value6 = group.value) === null || _group$value6 === void 0 ? void 0 : _group$value6.members.push(user);
      });
      channel.bind("user_pending", function (_ref2) {
        var id = _ref2.id,
            status = _ref2.status;
        return updatePendingStatus(id, status);
      });
      channel.bind("user_remove", function (id) {
        return unlink(id);
      });
    };

    var edited = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resource) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (group.value) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                group.value = _objectSpread(_objectSpread({}, group.value), resource);
                metaStore.head.title = group.value.name;
                metaStore.head.description = group.value.description;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function edited(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    var onRemove = function onRemove() {
      var dialog = dialogAPI.warning({
        title: "Warning",
        content: "This group and all its messages will be permanently deleted. Are you sure you want to continue?",
        positiveText: "Delete",
        negativeText: "Cancel",
        onPositiveClick: function () {
          var _onPositiveClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    dialog.loading = true;
                    _context4.next = 3;
                    return remove();

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          function onPositiveClick() {
            return _onPositiveClick.apply(this, arguments);
          }

          return onPositiveClick;
        }()
      });
    };

    var remove = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                loadingBar.start();
                _context5.prev = 1;

                if (group.value) {
                  _context5.next = 4;
                  break;
                }

                throw new Error("Group not found");

              case 4:
                _context5.next = 6;
                return http.delete("/groups/".concat(group.value.groupId));

              case 6:
                loadingBar.finish();
                _context5.next = 9;
                return router.push({
                  name: "Groups"
                });

              case 9:
                messageAPI.success("The group \"".concat(group.value.name, "\" has been deleted"));
                _context5.next = 20;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](1);
                loadingBar.error();
                _context5.t1 = messageAPI;
                _context5.next = 18;
                return handleError(_context5.t0, {
                  placeholder: "There was an error during the deletion"
                });

              case 18:
                _context5.t2 = _context5.sent;

                _context5.t1.error.call(_context5.t1, _context5.t2);

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 12]]);
      }));

      return function remove() {
        return _ref4.apply(this, arguments);
      };
    }();

    var link = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(user) {
        var member;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (group.value) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                member = {
                  id: user.id,
                  userName: user.userName,
                  addedDate: DateTime.now().toISO(),
                  pendingAcceptation: true
                };
                group.value.members.push(member);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function link(_x3) {
        return _ref5.apply(this, arguments);
      };
    }();

    var unlink = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
        var _userStore$user2;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (group.value) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                if (!(id !== ((_userStore$user2 = userStore.user) === null || _userStore$user2 === void 0 ? void 0 : _userStore$user2.id))) {
                  _context8.next = 5;
                  break;
                }

                group.value.members = group.value.members.filter(function (m) {
                  return m.id !== id;
                });
                return _context8.abrupt("return");

              case 5:
                unlisten();
                dialogAPI.warning({
                  title: "Group unavailable",
                  content: "This group has been updated or deleted and is no longer accessible to you.",
                  positiveText: "Leave",
                  maskClosable: false,
                  closeOnEsc: false,
                  closable: false,
                  onPositiveClick: function () {
                    var _onPositiveClick2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                      return regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              _context7.next = 2;
                              return router.push({
                                name: "Groups"
                              });

                            case 2:
                              return _context7.abrupt("return", _context7.sent);

                            case 3:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee7);
                    }));

                    function onPositiveClick() {
                      return _onPositiveClick2.apply(this, arguments);
                    }

                    return onPositiveClick;
                  }()
                });

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function unlink(_x4) {
        return _ref6.apply(this, arguments);
      };
    }();

    var updatePendingStatus = function updatePendingStatus(id, status) {
      if (!group.value) return;
      var member = group.value.members.find(function (m) {
        return m.id === id;
      });
      if (!member) return;
      member.pendingAcceptation = status;
    };

    var onLeave = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var dialog;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                dialog = dialogAPI.warning({
                  title: "Warning",
                  content: "You will not be able to join this group again unless you receive a new invitation. Are you sure you want to continue?",
                  positiveText: "Leave",
                  negativeText: "Cancel",
                  onPositiveClick: function () {
                    var _onPositiveClick3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                      return regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while (1) {
                          switch (_context9.prev = _context9.next) {
                            case 0:
                              dialog.loading = true;
                              leave();

                            case 2:
                            case "end":
                              return _context9.stop();
                          }
                        }
                      }, _callee9);
                    }));

                    function onPositiveClick() {
                      return _onPositiveClick3.apply(this, arguments);
                    }

                    return onPositiveClick;
                  }()
                });

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function onLeave() {
        return _ref7.apply(this, arguments);
      };
    }();

    var leave = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _userStore$user3;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;

                if (group.value) {
                  _context11.next = 3;
                  break;
                }

                throw new Error("Group not found");

              case 3:
                unlisten();
                _context11.next = 6;
                return http.delete("/groups/".concat(group.value.groupId, "/users"), {
                  data: {
                    usersIds: [(_userStore$user3 = userStore.user) === null || _userStore$user3 === void 0 ? void 0 : _userStore$user3.id]
                  }
                });

              case 6:
                _context11.next = 8;
                return router.push({
                  name: "Groups"
                });

              case 8:
                messageAPI.success("You leaved the \"".concat(group.value.name, "\" group"));
                _context11.next = 18;
                break;

              case 11:
                _context11.prev = 11;
                _context11.t0 = _context11["catch"](0);
                _context11.t1 = messageAPI;
                _context11.next = 16;
                return handleError(_context11.t0, {
                  placeholder: "There was an error during the leaving process"
                });

              case 16:
                _context11.t2 = _context11.sent;

                _context11.t1.error.call(_context11.t1, _context11.t2);

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 11]]);
      }));

      return function leave() {
        return _ref8.apply(this, arguments);
      };
    }();

    var unlisten = function unlisten() {
      var _channel2, _channel3;

      (_channel2 = channel) === null || _channel2 === void 0 ? void 0 : _channel2.unsubscribe();
      (_channel3 = channel) === null || _channel3 === void 0 ? void 0 : _channel3.disconnect();
    };

    onUnmounted(function () {
      return unlisten();
    });
    load();
    return function (_ctx, _cache) {
      var _component_n_h1 = _resolveComponent("n-h1");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_space = _resolveComponent("n-space");

      var _component_n_text = _resolveComponent("n-text");

      var _component_n_ellipsis = _resolveComponent("n-ellipsis");

      var _component_n_p = _resolveComponent("n-p");

      var _component_n_tag = _resolveComponent("n-tag");

      var _component_router_link = _resolveComponent("router-link");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      var _directive_watch_overflow = _resolveDirective("watch-overflow");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(loaders).fetch !== _unref(LoaderState).Loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(loaders).fetch !== _unref(LoaderState).Failed ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [group.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("header", _hoisted_2, [_createVNode(_component_n_h1, {
        class: "text-break mb-0 me-3"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(group.value.name), 1)];
        }),
        _: 1
      }), !group.value.isRoot ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_unref(isOwner) ? (_openBlock(), _createBlock(_component_n_space, {
        key: 0,
        size: "small"
      }, {
        default: _withCtx(function () {
          return [_createVNode(GroupEditionAction, {
            group: group.value,
            onEdited: edited
          }, {
            action: _withCtx(function (_ref9) {
              var trigger = _ref9.trigger;
              return [_createVNode(_component_n_button, {
                onClick: trigger
              }, {
                default: _withCtx(function () {
                  return [_hoisted_4];
                }),
                _: 2
              }, 1032, ["onClick"])];
            }),
            _: 1
          }, 8, ["group"]), _createVNode(_component_n_button, {
            type: "error",
            onClick: onRemove
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : (_openBlock(), _createBlock(_component_n_button, {
        key: 1,
        type: "error",
        onClick: onLeave
      }, {
        default: _withCtx(function () {
          return [_hoisted_6];
        }),
        _: 1
      }))])) : _createCommentVNode("", true)]), _unref(owner) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_n_text, {
        depth: "3"
      }, {
        default: _withCtx(function () {
          return [_hoisted_8, _createVNode(_component_n_text, {
            strong: "",
            depth: "3"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(owner).userName), 1)];
            }),
            _: 1
          })];
        }),
        _: 1
      })])) : _createCommentVNode("", true), group.value.description && group.value.description.trim().length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_unref(NH3), {
        class: "mb-3",
        ref_key: "descriptionTitle",
        ref: descriptionTitle
      }, {
        default: _withCtx(function () {
          return [_hoisted_9];
        }),
        _: 1
      }, 512), _createVNode(_component_n_p, {
        class: "text-break white-space-pre-line mt-0"
      }, {
        default: _withCtx(function () {
          return [!fullDescription.value ? _withDirectives((_openBlock(), _createBlock(_component_n_ellipsis, {
            key: 0,
            "line-clamp": 5,
            tooltip: false,
            onOverflowStatus: _cache[0] || (_cache[0] = function (e) {
              return descriptionOverflow.value = e.detail;
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(group.value.description), 1)];
            }),
            _: 1
          })), [[_directive_watch_overflow]]) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(group.value.description), 1)], 64))];
        }),
        _: 1
      }), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_n_button, {
        secondary: "",
        type: "info",
        onClick: switchDescriptionState
      }, {
        default: _withCtx(function () {
          return [!fullDescription.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_hoisted_10], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_11], 64))];
        }),
        _: 1
      })], 512), [[_vShow, descriptionOverflow.value]])], 64)) : _createCommentVNode("", true), _createVNode(_unref(NH3), null, {
        default: _withCtx(function () {
          return [_hoisted_12, _createVNode(_component_n_tag, {
            size: "small",
            class: "rounded-2 ms-1"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(group.value.messagesNb), 1)];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'NewMessage',
          params: {
            gid: group.value.groupId
          }
        },
        class: "text-decoration-none"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            type: "info",
            class: "mb-4"
          }, {
            default: _withCtx(function () {
              return [_hoisted_13];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["to"]), _createElementVNode("div", _hoisted_14, [_createVNode(MessagesList, {
        messages: _unref(messages),
        group: group.value,
        minimizable: true,
        "max-lines": 2,
        "show-groups": false,
        loader: _unref(loaders).fetch,
        error: _unref(errors).fetch,
        onRetry: load
      }, null, 8, ["messages", "group", "loader", "error"])]), _createVNode(_unref(NH3), null, {
        default: _withCtx(function () {
          return [_hoisted_15, _createVNode(_component_n_tag, {
            size: "small",
            class: "rounded-2 ms-1"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(group.value.membersNb), 1)];
            }),
            _: 1
          })];
        }),
        _: 1
      }), !group.value.isRoot && _unref(isOwner) ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(MemberLinkAction, {
        groupId: group.value.groupId,
        excluded: group.value.members,
        onLink: link
      }, {
        action: _withCtx(function (_ref10) {
          var trigger = _ref10.trigger,
              label = _ref10.label;
          return [_createVNode(_component_n_button, {
            type: "success",
            onClick: trigger,
            class: "me-3"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(label), 1)];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 1
      }, 8, ["groupId", "excluded"]), _createVNode(GroupInvitationUIAction, {
        groupId: group.value.groupId
      }, {
        action: _withCtx(function (_ref11) {
          var trigger = _ref11.trigger,
              label = _ref11.label;
          return [_createVNode(_component_n_button, {
            type: "info",
            onClick: trigger
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(label), 1)];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 1
      }, 8, ["groupId"])])) : _createCommentVNode("", true), _createVNode(MembersUI, {
        members: _unref(members),
        groupId: group.value.groupId,
        owner: _unref(owner),
        loader: _unref(loaders).fetch,
        error: _unref(errors).fetch,
        onRetry: load,
        onUnlink: _cache[1] || (_cache[1] = function (user) {
          return unlink(user.id);
        })
      }, null, 8, ["members", "groupId", "owner", "loader", "error"])], 64)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_n_result, {
        key: 1,
        status: "error",
        title: notFound.value ? 'Not found' : 'Error',
        description: _unref(errors).fetch
      }, {
        footer: _withCtx(function () {
          return [!notFound.value ? (_openBlock(), _createBlock(_component_n_button, {
            key: 0,
            onClick: load
          }, {
            default: _withCtx(function () {
              return [_hoisted_17];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["title", "description"]))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_n_skeleton, {
        class: "skeleton-item title"
      })]), _createVNode(_component_n_skeleton, {
        class: "skeleton-item mb-2"
      }), _createVNode(_component_n_skeleton, {
        class: "skeleton-item mb-4",
        style: {
          "width": "70%"
        }
      }), _createVNode(_component_n_skeleton, {
        class: "skeleton-item subtitle mb-2"
      }), _createVNode(_component_n_skeleton, {
        sharp: false,
        class: "skeleton-item information mb-4"
      })], 64))]);
    };
  }
});